import { all, AllEffect, call, fork, put, takeLatest } from '@redux-saga/core/effects';
import { Effect } from 'redux-saga/effects';
import axios from 'axios';

import {
  GET_VISITOR_SIMPLE_AUTH_REQUEST,
  GET_VISITOR_SIMPLE_AUTH_SUCCESS,
  GET_VISITOR_SIMPLE_AUTH_FAILURE,
  COMMON_FAILURE,
} from '../../actions';
import visitorRegisterService from '../../services/visitorRegisterService';

function* getSimpleAuth(action: any): Generator<unknown> {
  try {
    const res: any = yield call(visitorRegisterService(action).getSimpleAuth);
    if (res && res.status === 200) {
      yield put({
        type: GET_VISITOR_SIMPLE_AUTH_SUCCESS,
        res: res.data,
      });
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_VISITOR_SIMPLE_AUTH_FAILURE,
        error: { message: 'エラーが発生しました' },
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response?.data,
      });
      if (error.response && error.response.status >= 400) {
        action.history.push('/system-error');
      }
    }
    action.history.push('/systemError');
  }
}

function* watchGetSimpleAuth() {
  yield takeLatest(GET_VISITOR_SIMPLE_AUTH_REQUEST, getSimpleAuth);
}

export default function* simpleAuthSaga(): Generator<AllEffect<Effect>> {
  yield all([fork(watchGetSimpleAuth)]);
}
